import axios from 'axios';

import { getAdminIdToken, hasAnyPermission } from '@/api/admin-access';
import { permissionRequirementForApiRequest } from '@/config/permissions';
import { Constants } from '@/constants';
import { UserStore } from '@/stores';

let requestInterceptor: number | null = null;

const isAdminApiRequest = (url?: string) => {
  if (!url) return false;
  return url.startsWith(Constants.apiPath) || url.startsWith('/');
};

export const installAdminApiClient = () => {
  if (requestInterceptor !== null) return;
  requestInterceptor = axios.interceptors.request.use(async (config) => {
    if (!isAdminApiRequest(config.url)) return config;

    const token = await getAdminIdToken();
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;

    const requirement = permissionRequirementForApiRequest(
      config.url,
      config.method
    );
    const { access, loadingAccess } = UserStore.getRawState();
    if (
      requirement &&
      !loadingAccess &&
      !hasAnyPermission(access, requirement.keys, requirement.action)
    ) {
      return Promise.reject(
        new Error(
          `You do not have ${requirement.action} permission for this action.`
        )
      );
    }
    return config;
  });
};
